import React from 'react'

import { ClockDefault, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import highlightTranslation from 'Pods/Shared/Utils/highlightTranslation'

import { PLAN_CHANGE_KIND } from '../../../constants'
import { planChangeTargetShape } from '../../../propTypes'

const KEY = 'subscription_management.plan_change'
const CLOCK_SIZE = { width: '36', height: '36' }

function DoneStep({
  selection, tier, effectiveDate, translate,
}) {
  const isDowngrade = selection.kind === PLAN_CHANGE_KIND.DOWNGRADE
  const highlights = isDowngrade
    ? { plan: translate(`${KEY}.tiers.${selection.tier}`) }
    : { monthly: translate(`${KEY}.done.monthly_billing`) }

  return (
    <div className="plan-change-modal__body plan-change-modal__body--done">
      <span className="plan-change-modal__done-icon">
        <Icon svgComponent={ClockDefault} size={CLOCK_SIZE} className="plan-change-modal__clock" notSpaced />
      </span>
      <p className="cgt-body-md plan-change-modal__done-text" role="status">
        {highlightTranslation(
          translate,
          `${KEY}.done.${isDowngrade ? 'downgrade' : 'to_monthly'}`,
          highlights,
          'cgt-body-md-semibold plan-change-modal__emphasis',
          { date: effectiveDate, currentPlan: translate(`${KEY}.tiers.${tier}`) },
        )}
      </p>
    </div>
  )
}

DoneStep.propTypes = {
  selection: planChangeTargetShape.isRequired,
  tier: string.isRequired,
  effectiveDate: string.isRequired,
  translate: func.isRequired,
}

export default DoneStep
